export default {"src":"/_next/static/image/public/images/Carttransferring.6cfbff9a18edbbefbbfb3b4c4fb96f6a.gif","height":346,"width":346};